import { Toast, Tooltip } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));

})();


// jquery block
(function ($) {
	let log = console.log.bind(console);

	// show the modal when clicking the button
	$('.authenticated-modal a').on('click', function (e) {
		e.stopPropagation();
		// $( this ).find( '[autofocus]' ).focus();
		$('#authenticatedModal').modal('show');
		return false;
	});

	// closes the modal
	$('.modal button').on('hidden.bs.modal click', function (e) {
		$('.modal').modal('hide');
	});
})(jQuery);


// jquery block
(function ($) {
	const $headerMobileToggleContainer = document.createElement('div');
	const $headerMobileToggle = document.createElement('div');
	$($headerMobileToggleContainer).addClass('header-mobile-toggle-container');
	$($headerMobileToggle).addClass('header-mobile-toggle');
	$($headerMobileToggleContainer).append($headerMobileToggle);
	$('header.page__header').append($headerMobileToggleContainer);

	$($headerMobileToggleContainer).on('click', function (e) {
		$('body').toggleClass('header-mobile-open');
	});

	$('header ul.nav').append(`<li class="nav-item show-mobile search-button">
  <a href="/busca" class="nav-link" data-drupal-link-system-path="/busca">Buscar</a>
</li>`);
})(jQuery);


//função para mover os botões da pagina de estudo para outra div
(function ($) {
	if ($('body').hasClass('node-type--estudos')) {
		document.addEventListener('DOMContentLoaded', function () {
			var newParent = document.querySelector('.estudos-internas .col:nth-child(2)');
			try {
				var childToMove = $('.paragraph_bloco_webform');
				childToMove.appendTo(newParent);
			} catch (error) {
			}

			try {
				var childToMove2 = $('.paragraph_attachments');
				childToMove2.appendTo(newParent);
			} catch (error) {
			}

			try {
				var childToMove = $('.paragraph_cta');
				childToMove.appendTo(newParent);
			} catch (error) {	
			}
		})
	}
})(jQuery);


//Função Taxonomia Ativa
(function ($) {
	$(function () {
		var titulo_pagina = document.title;
		var primeira_palavra = titulo_pagina.split(' ')[0];
		try {
			$('.tabs-cloud .field-content > a:nth-child(2)').filter(function () {
				return $(this).text().replace(/\s+/g, ' ').trim() === primeira_palavra;
			}).addClass('is_active');
		} catch (error) {
			console.log('não foi encontrado o filho');
		}
	});
})(jQuery);


//Função para mover o bloco div do form de busca para o bloco de navegação principal
(function ($) {
	$(function () {
		const header = $('header > .header_container > .block--navegacaoprincipal');
		try {
			const childToMove = $('header > .header_container > .block--formulariodebusca');
			childToMove.appendTo(header);

		} catch (error) {
			console.log("Não foi encontrado a div Filho ")
		}

		const iconBusca = header.find('#icon-busca');
		const formBarraBusca = header.find('.block--formulariodebusca');
		const inputBarraBusca = formBarraBusca.find('form > .form-item > input');

		//mudar attribute name da barra de input das paginas
		const barraDeBusca = $('form').find('.form-search');
		barraDeBusca.attr('name', 'search_api_fulltext');

		function toggleBarraBusca() {
			formBarraBusca.slideToggle(200);
			iconBusca.toggleClass('mostrando');
			inputBarraBusca.val('');
		}

		iconBusca.on('click', function () {
			toggleBarraBusca();
			inputBarraBusca.focus();
		});

		$(document).on('click', function (event) {
			// Verifica se o clique foi fora da div
			if (!$(event.target).closest(formBarraBusca).length && !$(event.target).is(iconBusca) && (formBarraBusca.css('display') === 'block')) {
				toggleBarraBusca();
			}
		});
	})
})(jQuery);


//Função para mover as div da view estudos no carroussel
/* (function ($) {
	$(document).ready(function () {

		$(".carroussel-content").each(function () {
			var container = $(this);
			var destino = container.find(".carroussel-body");

			["views-field-title", "views-field-body", "views-field-nid"].forEach(function (className) {
				container.find("." + className).appendTo(destino);
			});
		});
	})
})(jQuery); */


/* Limita a quantidade de caractares no resumo dos itens do carrossel - home page */
(function ($) {
	$(function () {
		var fieldBodies = $('.carrossel-item .views-field-body .field-content');
		fieldBodies.each(function () {
			var text = $(this).text();
			if (text.length > 150) {
				$(this).text(text.substring(0, 150) + '...');
			}
		});
	});
})(jQuery);

(function ($, Drupal) {
  Drupal.behaviors.forceModalClass = {
    attach: function () {
      // Evita múltiplos binds
      if (!window.modalClassBound) {
        $(document).on('dialogopen', function (event) {
          const $dialog = $(event.target).closest('.ui-dialog');
          const $trigger = $(event.target);

        //   if ($trigger.is('[data-dialog-options*="modal-download"]')) {
            $dialog.addClass('modal-download');
        //   }
        });

        window.modalClassBound = true;
      }
    }
  };
})(jQuery, Drupal);

document.addEventListener("DOMContentLoaded", function () {
	if (window.innerWidth <= 768) {
	  const fieldDiv = document.querySelector(
		".field.field--name-body.field--type-text-with-summary.field--label-hidden.field__item"
	  );
  
	  if (!fieldDiv) return;
  
	  const images = fieldDiv.querySelectorAll("img");
	  const secondImage = images[1]; // Pega a segunda imagem
  
	  const footerContent = document.querySelector(".footer-content");
  
	  if (secondImage && footerContent) {
		footerContent.appendChild(secondImage);
	  }
	}
});